import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    demoUid: "",
    ab: "A"
  },
  getters: {
    demoUid: state => {
      return state.demoUid;
    },
    ab: state => {
      return state.ab;
    }
  },
  mutations: {
    setDemoUid(state, value) {
      state.demoUid = value;
    },
    setAB(state, value) {
      state.ab = value;
    }
  }
})

export default store;


// WEBPACK FOOTER //
// ./src/vuex.js